import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview", "customBlock", "template"]

  static values = {
    name: { type: String, default: "Baustelle Alpha" },
    number: { type: String, default: "KST-001" },
    previewUrl: String,
  }

  connect() {
    this.toggleCustomBlock()
  }

  update() {
    this.toggleCustomBlock()
    if (this.selectTarget.value === "custom") {
      this.updateCustomPreview()
    } else {
      this.previewTarget.textContent = this.formatSiteName(this.selectTarget.value)
    }
  }

  toggleCustomBlock() {
    if (!this.hasCustomBlockTarget) return
    this.customBlockTarget.classList.toggle("hidden", this.selectTarget.value !== "custom")
  }

  insertToken(event) {
    const token = event.currentTarget.dataset.token
    if (!this.hasTemplateTarget || !token) return

    const input = this.templateTarget
    const start = input.selectionStart ?? input.value.length
    const end = input.selectionEnd ?? input.value.length
    input.value = input.value.slice(0, start) + token + input.value.slice(end)
    const caret = start + token.length
    input.setSelectionRange(caret, caret)
    input.focus()
    this.updateCustomPreview()
  }

  applyExample(event) {
    const template = event.currentTarget.dataset.template
    if (!this.hasTemplateTarget || !template) return

    this.templateTarget.value = template
    this.templateTarget.focus()
    this.updateCustomPreview()
  }

  async updateCustomPreview() {
    if (!this.hasTemplateTarget || !this.hasPreviewUrlValue) return

    const template = this.templateTarget.value
    try {
      const response = await fetch(
        `${this.previewUrlValue}?template=${encodeURIComponent(template)}`,
        {
          headers: {
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          },
        },
      )
      if (response.ok) {
        this.previewTarget.textContent = await response.text()
      }
    } catch (error) {
      console.error("Failed to update site name preview:", error)
    }
  }

  formatSiteName(format) {
    const name = this.nameValue
    const number = this.numberValue

    switch (format) {
      case "name_with_number":
        return `${name} (${number})`
      case "number_with_name":
        return `${number} - ${name}`
      case "number_only":
        return number
      default:
        return name
    }
  }
}
